import * as React from "react";
import { Stack, Typography, Paper } from "@mui/material";

export default function BookingsPage() {
    return (
        <Stack spacing={2}>
            <Typography variant="h5" sx={{ fontWeight: 1000 }}>Bookings</Typography>
            <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3 }}>
                <Typography color="text.secondary">Coming next: bookings table + details</Typography>
            </Paper>
        </Stack>
    );
}
